import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // 跳转
  const API_BASE = process.env.REACT_APP_API_BASE || (typeof window !== "undefined" && window.location?.hostname ? `http://${window.location.hostname}:3001` : "http://localhost:3001");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Invalid credentials");

      // 保存用户信息
      setUser(data);
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("token", data.token); 
      if (data.isAdmin) {
        localStorage.setItem("admin-session-expires-at", String(Date.now() + 60 * 60 * 1000));
      } else {
        localStorage.removeItem("admin-session-expires-at");
      }
      setError("");

      // 根据是否是管理员跳转
      if (data.isAdmin) {
        navigate("/admin");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-orange-50 via-white to-gray-100">
      <div className="relative w-80 sm:w-96 p-[2px] rounded-2xl bg-gradient-to-r from-orange-400 via-yellow-400 to-pink-400 animate-glow">
        <div className="bg-white rounded-2xl p-6 shadow-md">
          <h2 className="text-xl font-bold text-center mb-2">Welcome</h2>
          <p className="text-center text-gray-500 mb-6 text-sm">Please log in to continue</p>

          {error && <p className="text-[var(--primary)] text-sm text-center mb-4">{error}</p>}

          <form onSubmit={handleLogin} className="flex flex-col gap-4">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 p-2 rounded-lg"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 p-2 rounded-lg"
              required
            />
            <button
              type="submit"
              className="w-full bg-[var(--primary)] hover:bg-green-600 text-white py-2 rounded-lg font-semibold transition-all duration-300"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
